require('./ValidationModal.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');

class ValidationModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = { isOpen: this.props.openModal };

        this.handleOnRequestContinue = this.handleOnRequestContinue.bind(this);
        this.handleRoute = this.handleRoute.bind(this);
    }

    componentWillMount() {
        const { shouldOpen, contractWizard, initialLoad } = this.props;
        shouldOpen && initialLoad && this.setState({ isOpen: shouldOpen(contractWizard) });
    }

    componentWillReceiveProps(nextProps) {
        const { shouldOpen, initialLoad, contractWizard } = this.props;

        if (!initialLoad) {
            let isOpen = nextProps.openModal;
            if (shouldOpen) {
                isOpen = isOpen && shouldOpen(contractWizard);
            }
            this.setState({ isOpen });
        }
    }

    handleOnRequestContinue() {
        const { handleOnRequestContinue, shouldOpen, initialLoad } = this.props;

        if (initialLoad && shouldOpen) {
            this.setState({ isOpen: false });
        } else {
            handleOnRequestContinue();
        }
    }

    handleRoute() {
        this.props.history.push(this.props.cancelRoute);
    }

    render() {
        const { title, children, handleOnRequestClose, allowContinue, contractWizard, cancelRoute, leaveButtonText, onClosed, onContinue, onBack, customCloseButton } = this.props;
        const { isOpen } = this.state;
        const allowContinueResult = typeof (allowContinue) === 'boolean' ? allowContinue : allowContinue(contractWizard);
        let footer = 'action';
        let primaryText = this.props.primaryButtonText;
        let secondaryText = '';
        let onSecondaryClick = () => {};
        let acceptHandler;

        if (!!cancelRoute) {
            acceptHandler = this.handleRoute;
        } else {
            acceptHandler = allowContinueResult ? this.handleOnRequestContinue : handleOnRequestClose;
        }

        if (allowContinueResult) {
            footer = 'navigation';
            primaryText = this.props.primaryButtonTextAllowContinue;
            secondaryText = leaveButtonText;
            onSecondaryClick = handleOnRequestClose;
        }

        function onClose(){
            onClosed()
            handleOnRequestClose()
        }

        function onNext(){
            onContinue()
            acceptHandler()
        }

        function onCancel(){
            onBack()
            onSecondaryClick()
        }

        return (
            <OKModal
                content={children}
                customCloseButton={customCloseButton}
                footerType={footer}
                isOpen={isOpen}
                onCloseCallback={onClose}
                onPrimaryButtonClick={onNext}
                onSecondaryButtonClick={onCancel}
                primaryButtonText={primaryText}
                secondaryButtonText={secondaryText}
                title={title}
            />
        )
    }
}

ValidationModal.defaultProps = {
    openModal: true,
    allowContinue: true,
    initialLoad: false,
    leaveButtonText: 'contractsView-validationModalLeaveMessage',
    primaryButtonText: 'contractsView-validationModalAcceptMessage',
    primaryButtonTextAllowContinue: 'contractsView-validationModalContinueMessage',
    customCloseButton: null,
    onClosed: ()=>{},
    onContinue: ()=>{},
    onBack: ()=>{}
};

ValidationModal.propTypes = {
    openModal: PropTypes.bool,
    handleOnRequestClose: PropTypes.func.isRequired,
    handleOnRequestContinue: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    allowContinue: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func
    ]).isRequired,
    children: PropTypes.object,
    customCloseButton: PropTypes.node,
    history: PropTypes.object.isRequired,
    shouldOpen: PropTypes.func,
    initialLoad: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    cancelRoute: PropTypes.string,
    contractWizard: PropTypes.object,
    leaveButtonText: PropTypes.string,
    primaryButtonText: PropTypes.string,
    primaryButtonTextAllowContinue: PropTypes.string,
    onClosed: PropTypes.func,
    onContinue: PropTypes.func,
    onBack: PropTypes.func
};

module.exports = withRouter(ValidationModal);
